import { useCallback } from 'react';
import { useUsageScreen } from '../context/UsageScreenContext';
import { MarketplaceEventProps } from '../events/properties';

export function useMergeTrackEventProps() {
  const { screen, subscreen } = useUsageScreen();

  return useCallback(
    (eventProps: Partial<MarketplaceEventProps>) => {
      const finalEventProps: Partial<MarketplaceEventProps> = {
        ...eventProps,
      };

      if (screen && !finalEventProps.screen) {
        finalEventProps.screen = screen;
      }

      if (subscreen && !finalEventProps.subscreen) {
        finalEventProps.subscreen = subscreen;
      }

      return finalEventProps;
    },
    [screen, subscreen]
  );
}
